import React from 'react'
type WarningStatusIconProps = {
  width?: string
  height?: string
}

const WarningStatusIcon = ({
  width = '32',
  height = '32',
}: WarningStatusIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 32 32'
      fill='none'
    >
      <circle
        cx='16'
        cy='16'
        r='16'
        fill='#F4821F'
      />
      <path
        d='M15.9999 14.0002V16.6668M15.9999 19.3335H16.0065M15.0768 10.5946L9.5935 20.0657C9.28936 20.591 9.13729 20.8537 9.15977 21.0693C9.17937 21.2573 9.27789 21.4282 9.43079 21.5394C9.6061 21.6668 9.9096 21.6668 10.5166 21.6668H21.4831C22.0901 21.6668 22.3937 21.6668 22.569 21.5394C22.7219 21.4282 22.8204 21.2573 22.84 21.0693C22.8625 20.8537 22.7104 20.591 22.4063 20.0657L16.923 10.5946C16.62 10.0712 16.4684 9.80947 16.2707 9.72157C16.0983 9.64489 15.9014 9.64489 15.729 9.72157C15.5313 9.80947 15.3798 10.0712 15.0768 10.5946Z'
        stroke='white'
        strokeWidth='2'
        strokeLinejoin='round'
        strokeLinecap='round'
      />
    </svg>
  )
}

export default WarningStatusIcon
